import React from 'react';
import PropTypes from 'prop-types';

const SlideList = ({ items, marginLeft, sliderCN, containerCN, inputRef }) =>
  <div className={containerCN}>
    <div ref={inputRef} style={{ transform: `translateX(-${marginLeft}px)` }} className={sliderCN}>
      {items}
    </div>
  </div>;

SlideList.propTypes = {
  inputRef: PropTypes.func.isRequired,
  items: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  marginLeft: PropTypes.number,
  sliderCN: PropTypes.string,
  containerCN: PropTypes.string,
};

SlideList.defaultProps = {
  items: [],
  marginLeft: 0,
  sliderCN: '',
  containerCN: '',
};

export default SlideList;



// WEBPACK FOOTER //
// ./src/desktop/components/Carousel/SlideList.js